import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-box" }
const _hoisted_2 = {
  key: 0,
  class: "dialog"
}
const _hoisted_3 = { class: "dialog__links" }
const _hoisted_4 = { class: "dialog__tooltip" }

import AuthenticationError from "@/components/AuthenticationError.vue"
import {computed, ref} from "vue"
import {useStore} from "vuex";
import router from '@/router';
import { isUserAuthenticated } from '@/utils/user';

interface TooltipOptions {
  title: string,
  text: string,
  open: boolean
}

interface User {
  login: string,
  password: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthenticationDialogTest',
  setup(__props) {

const store = useStore()
const inProcess = ref(false);

const tooltip = ref<TooltipOptions>({
  title: '',
  text: '',
  open: false
})

const user = ref<User>({
  login: '',
  password: ''
})

const error = computed(() => {
  return store.getters['user/loginError']
})

const login = async (e: Event, user: User) => {
  e.preventDefault()
  try {
    inProcess.value = true
    if (!user.password.length) {
      store.commit('user/setError', 'Введите пароль')
      return
    }
    if (!user.login.length) {
      store.commit('user/setError', 'Введите логин')
      return
    }
    closeTooltip()
    await store.dispatch('user/loginTest', user)
  } catch (error) {
    console.error(error)
  } finally {
    inProcess.value = false
  }
}

const closeTooltip = () => {
  tooltip.value.open = false
  tooltip.value.title = ''
  tooltip.value.text = ''
}

const changePassword = () => {
  router.push('/reset-pass')
}

// Редирект со страницы авторизации если пользователь авторизован
if (!window.location.host.startsWith('localhost') && isUserAuthenticated()) {
  router.push("/");
}

return (_ctx: any,_cache: any) => {
  const _component_vita_input = _resolveComponent("vita-input")!
  const _component_vita_button = _resolveComponent("vita-button")!
  const _component_vita_tooltip = _resolveComponent("vita-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "dialog__title" }, "Вход", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("p", { class: "dialog__text" }, "Введите email и пароль, используемые в приложении “Планета Вита”.", -1)),
          _createElementVNode("form", {
            class: "dialog__form",
            onSubmit: _cache[2] || (_cache[2] = ($event: any) => (login($event, user.value)))
          }, [
            _createVNode(_component_vita_input, {
              placeholder: "Логин",
              type: "mail",
              icon: "mail",
              modelValue: user.value.login,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.login) = $event)),
              "data-qa": "auth-dialog-test-input-login"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_vita_input, {
              placeholder: "Пароль",
              type: "password",
              icon: "password",
              modelValue: user.value.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.password) = $event)),
              error: error.value,
              "data-qa": "auth-dialog-test-input-password"
            }, null, 8, ["modelValue", "error"]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("a", {
                class: _normalizeClass({disabled: inProcess.value}),
                onClick: changePassword,
                "data-qa": "auth-dialog-test-link-restore-password"
              }, "Восстановить пароль", 2),
              _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"height":"18px"} }, null, -1))
            ]),
            _createVNode(_component_vita_button, {
              disabled: inProcess.value,
              "data-qa": "auth-dialog-test-button-login"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Войти", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"])
          ], 32)
        ]))
      : (_openBlock(), _createBlock(AuthenticationError, {
          key: 1,
          error: error.value,
          onClickLink: changePassword
        }, null, 8, ["error"])),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_vita_tooltip, {
        open: tooltip.value.open,
        onClosed: closeTooltip,
        title: tooltip.value.title,
        text: tooltip.value.text
      }, null, 8, ["open", "title", "text"])
    ])
  ]))
}
}

})